export enum Currency {
    ETH = "ETH",
    MATIC = "MATIC",
    EUR = "EUR",
  }
  